export const beyondSandboxApis = [
    {
        type: "file",
        input: "apis/beyond-sandbox/v1/crowdfunding.yaml",
        path: "/products/beyond-sandbox/api-reference/crowdfunding"
    },
    {
        type: "file",
        input: "apis/beyond-sandbox/v1/microlending.yaml",
        path: "/products/beyond-sandbox/api-reference/microlending"
    },
    {
        type: "file",
        input: "apis/beyond-sandbox/v1/other.yaml",
        path: "/products/beyond-sandbox/api-reference/other"
    },
    {
        type: "file",
        input: "apis/beyond-sandbox/v1/payment-service.yaml",
        path: "/products/beyond-sandbox/api-reference/payment-service"
    },
    {
        type: "file",
        input: "apis/beyond-sandbox/v1/remittance.yaml",
        path: "/products/beyond-sandbox/api-reference/remittance"
    },
    {
        type: "file",
        input: "apis/beyond-sandbox/virtual-assets/v1/custodial-wallet-provider.yaml",
        path: "/products/beyond-sandbox/api-reference/virtual-assets/custodial-wallet-provider"
    },
    {
        type: "file",
        input: "apis/beyond-sandbox/virtual-assets/v1/exchange.yaml",
        path: "/products/beyond-sandbox/api-reference/virtual-assets/exchange"
    },
    {
        type: "file",
        input: "apis/beyond-sandbox/virtual-assets/v1/issuer.yaml",
        path: "/products/beyond-sandbox/api-reference/virtual-assets/issuer"
    },
    {
        type: "file",
        input: "apis/beyond-sandbox/virtual-assets/v1/payment-service-provider.yaml",
        path: "/products/beyond-sandbox/api-reference/virtual-assets/payment-service-provider"
    }
];
